import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Almacena',
    description: 'Controla el stock de tu negocio: productos, entradas, salidas, ajustes y avisos de reposición en un solo lugar.',
    placeholder: 'Control de stock',
    url: getOrigin()
}
